var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsBoolean, IsDateString, IsEnum, IsObject, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { CallRequestAction } from '../enums/call-request-action.enum.js';
export class CallRequest {
    user;
    callId;
    date = new Date();
    action;
    ignored;
    /** The call's office, when the request came from another office than the tab's (#1837). */
    officeId;
}
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    ValidateNested(),
    __metadata("design:type", UserProfileDto)
], CallRequest.prototype, "user", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CallRequest.prototype, "callId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CallRequest.prototype, "date", void 0);
__decorate([
    IsEnum(CallRequestAction),
    __metadata("design:type", String)
], CallRequest.prototype, "action", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CallRequest.prototype, "ignored", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], CallRequest.prototype, "officeId", void 0);
//# sourceMappingURL=call-request.dto.js.map